import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_DOCUMENTO_TIPO } from '../../data.const';
import {
  retrieveDocumentoTipoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteDocumentoTipoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_DOCUMENTO_TIPO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `documentoTipo`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveDocumentoTipoListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_DOCUMENTO_TIPO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteDocumentoTipoEpic;
